/* Approved v63 perspective, 3%. Native video compositing: no extra decode, canvas or download.
   Preserve source framing and existing centring; use unwarped boxes for overlay layout. */
(() => {
  'use strict';
  if (window.HoundModelPerspective) return;
  const amount = .03;
  const handles = /(?:venetian-red|vulture-black|auric-white|azure-blue)-hound-muscle-tee/;
  const sources = /(?:284d9380e5d347c292cb063e64c9188c|14b65e48561240a295e97b011ce81cf6|640e410d7407491b986f0cf9a6cd7095|13fc44d31fab4112becfaf1de44732c7|06c7976a516c4a5a923a4e4b96f0b5be|fabf3fd7a6d74593b16a293d81e97c36|c3b84ef8672e4e48b35357f16f7643bd|b97ec87c4ebc4525936ef176ecbe5280|mw-venetian-richer-v15-|mw-(?:black|white|blue)-consistent-v21-|hound-(?:black|white|blue)-consistent-v21-poster|hound-red-tee-richer-720-v16-poster)/;
  const sheet = document.createElement('style');
  sheet.id = 'hound-model-perspective-v64';
  document.head.appendChild(sheet);
  const ids = new WeakMap(); let serial = 0, pending = false;
  function matches(el) {
    if (el.matches('.product-loading-still')) return !!el.closest('[data-mobile-framing="richer-native"]');
    if (el.matches('.product-card__model')) return handles.test(el.closest('a')?.getAttribute('href') || '');
    if (sources.test(el.currentSrc || el.getAttribute('src') || el.getAttribute('poster') || '')) return true;
    return el.tagName === 'VIDEO' && [...el.querySelectorAll('source')].some(s => sources.test(s.src));
  }
  const selector = 'video.product-video,video.product-video-alt,video.hrp-figure__media,img.product-loading-still,img.product-mw-frame,img.hrp-spin__frame,img.product-card__model';
  function unwarpedRect(el) {
    // Synchronous style swap: layout reads see the original rectangle. Nothing paints between reads.
    const disabled = sheet.disabled; sheet.disabled = true;
    try { return el.getBoundingClientRect(); } finally { sheet.disabled = disabled; }
  }
  function matrix(w,h,nw,nh,fit,position,origin) {
    let rw=w, rh=h;
    if (nw && nh && (fit==='contain'||fit==='cover')) {
      const s=(fit==='contain'?Math.min:Math.max)(w/nw,h/nh); rw=nw*s;rh=nh*s;
    }
    const parts=position.split(/\s+/);
    const offset=(text,space)=>text?.endsWith('%')?space*parseFloat(text)/100:parseFloat(text)||0;
    const ox=offset(parts[0],w-rw), oy=offset(parts[1]||'50%',h-rh);
    const o=origin.split(/\s+/).map(parseFloat);
    // Coordinates relative to the existing CSS transform origin. Same homography as v63 shader.
    const top=oy+.08*rh-(o[1]||0), floor=oy+.925*rh-(o[1]||0), cx=ox+rw/2-(o[0]||0);
    const c=-amount/(floor-top), d=1+amount-c*top;
    return `matrix3d(1,0,0,0,${cx*c},${1+top*c},0,${c},0,0,1,0,${cx*(d-1)},${top*(d-1)},0,${d})`;
  }
  const resize=new ResizeObserver(schedule);
  function refresh() {
    pending=false;
    const media=[...document.querySelectorAll(selector)].filter(matches);
    const rules=[];
    sheet.disabled=true;
    try {
      for(const el of media) {
        if(!ids.has(el)) {ids.set(el,++serial);el.dataset.houndPerspective=String(serial);resize.observe(el);}
        const w=el.clientWidth,h=el.clientHeight;
        if(!w||!h)continue;
        const cs=getComputedStyle(el), nw=el.videoWidth||el.naturalWidth||720, nh=el.videoHeight||el.naturalHeight||1408;
        const base=cs.transform==='none'?'':cs.transform;
        rules.push(`[data-hound-perspective="${ids.get(el)}"]{transform:${base} ${matrix(w,h,nw,nh,cs.objectFit,cs.objectPosition,cs.transformOrigin)} !important;}`);
      }
      const css=rules.join('\n');if(sheet.textContent!==css)sheet.textContent=css;
    } finally {sheet.disabled=false;}
  }
  function schedule(){if(!pending){pending=true;requestAnimationFrame(refresh);}}
  window.HoundModelPerspective={unwarpedRect,refresh:schedule,amount};
  new MutationObserver(records=>{
    if(records.some(r=>r.target!==sheet && (r.type==='childList'||r.target.matches?.(selector)||r.target===document.body)))schedule();
  }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','style','class','hidden']});
  document.addEventListener('load',e=>{if(e.target.matches?.(selector))schedule();},true);
  document.addEventListener('loadedmetadata',schedule,true);
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  refresh();
})();
